import { apiClient } from './client';
import { ExtractionResult } from '../types';

export async function extractNew(file: File): Promise<{ data: ExtractionResult }> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await apiClient.post<{ data: ExtractionResult }>('/pdf/extract-new', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function extractAdd(companyId: string, file: File): Promise<{ data: { profile: unknown; document_id: string; confidence: unknown } }> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await apiClient.post(`/pdf/extract-add/${companyId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}
